<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Prim Türü</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
              <input type="text" class="form-control" v-model="value.Name" placeholder="Prim Türü"/>
            </v-validator> 
        </div>
        <div class="col-12">
            <label class="form-label">Sıra</label>
            <v-validator :errors="errors" parameter="Order" :watch="value.Order">
            <input type="number" class="form-control" v-model="value.Order" placeholder="Sıra"/>
            </v-validator> 
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        errors:Object
    }
}
</script>

<style>

</style>